import { render, staticRenderFns } from "./dynamicIframe.vue?vue&type=template&id=24449ea0"
import script from "./dynamicIframe.vue?vue&type=script&lang=js"
export * from "./dynamicIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports